import { createSlice } from '@reduxjs/toolkit';
const intialSelectContent =
    [{
        key: 'createNotes',
        title: 'Create Notes',
        state: 3,
        subType: [{
            title: 'Page 1',
            key: 'createNotes',
            state: 2,
            visible: true,
        }],
    },
    { key: 'conceptAndChapter', title: 'Add Concepts and Chapters', state: 3, },
    { title: 'Add Tags', key: 'tags', state: 3 }
    ];

const practiceSet=[
    {
        "key": "createPracticeSet",
        "title": "Create Practice Set",
        "state": 3,
        "subType": [
            {
                "key": "createPracticeSet",
                "state": 2,
                "title": "Question 1",
                "visible": true,
            }
        ]
    },
    {
        "key": "conceptAndChapter",
        "title": "Add Concepts and Chapters",
        "state": 3
    },
    {
        "title": "Add Tags",
        "key": "tags",
        "state": 3
    }
]
const notesSlice = createSlice({
    name: 'Notes',
    initialState: [...intialSelectContent],
    reducers: {
        addSubTypes: (state = [], actionType) => {
            return actionType.payload;
        },
        // these reducers not in use removed further  
        removeSubTypes: (state, actionType) => {
            const newState = [...actionType.payload]
            return { ...state, subTypes: newState };
        },
        addConceptAndChapter: (state, actionTypes) => {
            const concept = actionTypes.payload
            return { ...state, conceptAndChapter: concept }
        },
        addExtraTags: (state, actionTypes) => {
            const tags = actionTypes.payload;
            return { ...state, tags }
        },
        setPractiseSetContent: (state, actionTypes) => {
            return [...practiceSet];
        }
    }
});

const { actions, reducer } = notesSlice;
export default reducer;
export const notesActions = actions;